import RestResourceService from "@/services/RestResourcesService";
import errorParser from '@/utils/error-parser'


function initialState() {
    return {
        fast_search_items: null,
        search_url:'',
        newCode:''
    }
}

export default {
    state: initialState(),
    getters: {
        FAST_SEARCH_ITEMS: state => state.fast_search_items,
        SEARCH_URL: state => state.search_url,
        SEARCH_APP_NEW_CODE : state => state.newCode

    },
    mutations: {
        SET_SEARCH_APP_NEW_CODE(state,payload) {
            state.newCode = payload;
        },

        SET_SEARCH_URL(state, payload) {
            state.search_url = payload;
        },
        SET_FASTSEARCH_ITEMS(state, payload) {
            state.fast_search_items = payload;
        },
    },
    actions: {
        GET_SEARCH_URL:async ({commit}, url) => {
            commit('SET_GLOBAL_LOADING',true)
            return RestResourceService.getResources(url)
                .then((response) => {
                    commit('SET_SEARCH_URL', response.data);
                    commit('SET_GLOBAL_LOADING',false)
                    return response.data;
                })
                .catch((error) => {
                    commit('SET_GLOBAL_LOADING',false)
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: true,
                        redirectToLoginPage: true,
                        showNotification: true
                    });
                    throw new Error(error);
                })
        },
        POST_ITEM_FAST_SEARCH: async ({commit}, payload) => {
            commit('SET_GLOBAL_LOADING',true)
            return RestResourceService.postResources(payload.url, payload.form)
                .then((response) => {
                    commit('SET_FASTSEARCH_ITEMS', response.data);
                    commit('SET_GLOBAL_LOADING',false)

                    return response.data;
                })
                .catch((error) => {
                    commit('SET_GLOBAL_LOADING',false)
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        },

    }
}
